<template>
  <div>
    <div class="chart-wrapper">
      <span class="control">
        <sui-checkbox label="Last Day" radio value="day" v-model="chartShow" />&nbsp;
        <sui-checkbox label="Last Week" radio value="week" v-model="chartShow" />&nbsp;
        <sui-checkbox label="Last Month" radio value="30days" v-model="chartShow" />&nbsp;
        <sui-checkbox label="All" radio value="all" v-model="chartShow" />&nbsp;
      </span>
      <locaite-stats-hour-chart class="chart" :data="$store.state.admin.hourStats" :show="chartShow" />
    </div>
<!--    <locaite-stats-hour-list :data="$store.state.admin.hourStats" />-->
    <sui-divider />
    <sui-button @click="refresh">Refresh</sui-button>
  </div>
</template>

<script>
    import LocaiteStatsHourChart from "../charts/LocaiteStatsHourChart";
    export default {
      name: "LocaiteStats",
      components: {LocaiteStatsHourChart},
      data: function() {
          return {
              chartShow: "week",
          }
      },
      async mounted() {
        this.refresh()
      },
      methods: {
        async refresh() {
          await this.$store.dispatch('admin/hourStats')
        }
      }
    }
</script>

<style>
  .chart {
    height: 200pt;
  }

</style>
